<template>
  <div class="player-profile">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="is-size-1">Profile</h1>
        </div>
      </div>
    </div>
    <div class="container">
      <br/>
      <div class="box" v-show="showError">
        <article class="message is-danger">
          <div class="message-body">
            {{ errorMessage }}
          </div>
        </article>
      </div>

      <div class="box" style="margin-bottom: 20px;">
        <div class="box profile">
          <div class="columns">

            <div class="column is-one-quarter">
              <figure class="image" style="width: 150px;">
                <img class="profile-image" :src="$auth.user.picture" referrerpolicy="no-referrer">
              </figure>
              <h1 class="title" style="color: black !important;"> 
                <span class="is-size-4" v-if="profile.display_name == ''">{{ $auth.user.name }}</span>
                <span class="is-size-4" v-if="profile.display_name != ''">{{ profile.display_name }}</span>
              </h1>        
            </div>

            <div class="column is-one-quarter">
              <h3 class="is-size-5">Display name: </h3>
              <div v-show="!isEditingProfile" class="is-size-6">{{ profile.display_name }}</div>              
              <div v-show="isEditingProfile">
                <input class="input is-rounded" type="text" aria-placeholder="Display name?" placeholder="Display name?" v-model="profile.display_name"/>
              </div>
              <br/>
              <h3 class="is-size-5">Bio: </h3>
              <div v-show="!isEditingProfile" class="is-size-6">{{ profile.bio }}</div>              
              <div v-show="isEditingProfile">
                <textarea rows="2" class="textarea is-rounded" type="text" aria-placeholder="Bio?" placeholder="Bio?" v-model="profile.bio"></textarea>
              </div>
            </div>
            
            <div class="column is-one-quarter">
              <h3 class="is-size-5">Hometown: </h3>
              <div v-show="!isEditingProfile" class="is-size-6">{{ profile.home_town }}</div>
              <div v-show="isEditingProfile">
                  <input class="input is-rounded" type="text" aria-placeholder="Hometown?" placeholder="Hometown?" v-model="profile.home_town"/>
              </div>
              <br/>
              <h3 class="is-size-5">Country: 
                <span>
                  <country-flag v-bind:country='profile.country' size='normal' rounded/>
                </span>
              </h3>
              <div class="select is-rounded" v-show="isEditingProfile">
                <select v-model="profile.country">
                  <option selected></option>
                  <option v-for="(country, index) in country_list" v-bind:key="index" v-bind:value="country.alpha_2">
                    {{ country.country_name }}
                  </option>
                 </select>
              </div>
            </div>

            <div class="column is-one-quarter">
              <h3 class="is-size-5">Club:</h3>
              <div v-show="!isEditingProfile">
                <span class="is-size-6">{{ profile.club }}</span>
              </div>
              <div v-show="isEditingProfile">
                  <input class="input is-rounded" type="text" aria-placeholder="Club" placeholder="Club?" v-model="profile.club"/>
              </div>
              <br/>
              <h3 class="is-size-5">Axe: </h3>
              <div v-show="!isEditingProfile" class="is-size-6">{{ (profile.axe === 'Other' ? profile.axe_other : profile.axe) }}</div>
              <div class="select is-rounded" v-show="isEditingProfile">
                  <select v-model="profile.axe">
                      <option selected></option>
                      <option v-for="axe in axe_list" v-bind:key="axe.axe_name" v-bind:value="axe.axe_name">
                          {{ axe.axe_name }}
                      </option>
                      <option value="Other">Other</option>
                  </select>
              </div>
              <div v-show="isEditingProfile && profile.axe === 'Other'" style="padding-top: 10px;">
                <input class="input is-rounded" type="text" aria-placeholder="Axe Name?" placeholder="Axe Name?" v-model="profile.axe_other"/>
              </div>
            </div>
          </div>

          <div>

            <div>
              <div v-if="!isEditingProfile">
                Profile is Public? {{ (profile.public_profile == 'true' || profile.public_profile == true ? 'YES' : 'NO') }}
              </div>
              <div v-else>
                <label class="checkbox">
                  <input type="checkbox" v-model="profile.public_profile">
                  Profile is Public?
                </label>
                <p style="font-size: 0.7em;">(check to display your profile in the Members section)</p>
              </div>
            </div>

            <br/>
            <button class="button is-primary has-text-dark" v-show="isEditingProfile" v-on:click="submitProfile" style="margin-right: 10px;">
              <i class="fas fa-save" style="margin-right: 10px;"></i> Save 
            </button>
            <button class="button is-warning has-text-dark" v-show="isEditingProfile" v-on:click="cancelProfile">
              <i class="fas fa-times" style="margin-right: 10px;"></i> Cancel 
            </button>
            <button class="button is-primary has-text-dark" v-show="!isEditingProfile" v-on:click="editProfile">
              <i class="fas fa-edit" style="margin-right: 10px;"></i> Edit 
            </button>
          </div>
        </div>

        <div class="box profile">
          <div class="tabs">
            <ul style="border-bottom: none;">
              <li class="tab" v-bind:class="{ 'is-active': this.gameType === 'Solo' }">
                <span class="icon is-small"><i class="far fa-file-alt" aria-hidden="true"></i></span>
                <span class="is-clickable" v-on:click="pickGameType('Solo')">Solo</span>
              </li>
              <li class="tab" v-bind:class="{ 'is-active': this.gameType === GameType.ROUNDROBIN }">
                <span class="icon is-small"><i class="far fa-file-alt" aria-hidden="true"></i></span>
                <span class="is-clickable" v-on:click="pickGameType(GameType.ROUNDROBIN)">Round-Robbin</span>
              </li>
              <li class="tab" v-bind:class="{ 'is-active': this.gameType === GameType.TOURNAMENT }">
                <span class="icon is-small"><i class="far fa-file-alt" aria-hidden="true"></i></span>
                <span class="is-clickable" v-on:click="pickGameType(GameType.TOURNAMENT)">Tournament</span>
              </li>
              <li class="tab">
                <span class="icon is-small"><i class="far fa-file-alt" aria-hidden="true"></i></span>
                <span>Challenge</span>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <div class="container" v-if="gameType == GameType.ROUNDROBIN || gameType == GameType.TOURNAMENT">
            <div class="columns">
              <div class="column">
                <h3 class="is-size-4 has-text-weight-bold">Scorecards Submitted by subscriber:</h3>
              </div>
            </div>
            <div class="columns" v-if="scorecardHistory.length == 0 && pleaseWait">
              <div class="column">
                <h3 class="blink is-size-5">Please wait, loading score history...</h3>
              </div>
            </div>
            <div class="columns" v-show="scorecardHistory.length == 0 && !pleaseWait">
              <div class="column">
                <p class="is-size-5 has-text-warning">No scorecards found.</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="columns is-mobile" style="max-width: 350px;" v-for="scorecard in scorecardHistory" :key="scorecard._id">
                  <div class="column is-1">
                    <a title="View Scorecard" v-on:click="showScorecard(scorecard)"><i class="fas fa-bullseye"></i></a>
                  </div>
                  <div class="column is-1">
                    <a title="Share Scorecard" v-on:click="shareScorecard(scorecard)"><i class="fas fa-share"></i></a>
                  </div>
                  <div class="column is-1">
                    <a title="Email Scorecard" v-on:click="emailScorecard(scorecard)"><i class="fas fa-envelope"></i></a>
                  </div>
                  <div class="column is-9">
                    <a v-on:click="showScorecard(scorecard)">{{ scorecard.dateTimeStamp | formatDate }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container" v-if="gameType=='Solo'">

            <div class="columns">
              <div class="column">
                <h3 class="is-size-4 has-text-weight-bold">Results for {{ gameType }} Games</h3>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h3 class="is-size-4">Statistics</h3>
              </div>
            </div>

            <div class="box" style="background-color: lightgray;">
              <div class="columns" v-if="pleaseWaitStats">
                <div class="column">
                  <div class="blink"><p>Calculating stats...</p></div>
                </div>
              </div>

              <div class="columns" v-if="!pleaseWaitStats">
                <div class="column">
                  <ul>
                    <!--<li>Weekly Avg: {{ playerStatistics.weeklyAverage }}</li>
                    <li>Monthly Avg: {{ playerStatistics.monthlyAverage }}</li>-->
                    <li>Yearly Avg: {{ playerStatistics.yearlyAverage }}</li>
                    <li>Year Best 6: {{ playerStatistics.best6 }}</li>
                    <li>Year Best 36: {{ playerStatistics.best36 }}</li>
                    <li>Year Consecutive Bullseyes: {{ playerStatistics.consecutive_bulls }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h3 class="is-size-4">Average</h3>
              </div>
            </div>

            <div class="box" style="background-color: lightgray;">
              <div class="columns" v-if="!pleaseWaitStats">
                <div class="column">
                  <ul>
                    <li>Weekly Avg: {{ playerStatistics.weeklyAverage }}</li>
                    <li>Monthly Avg: {{ playerStatistics.monthlyAverage }}</li>
                    <li>Year Best 6: {{ playerStatistics.best6 }}</li>
                    <li>Year Best 36: {{ playerStatistics.best36 }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="columns" v-if="scorecardHistory.length == 0 && !pleaseWait">
              <div class="column">
                <p class="is-size-5 has-text-warning">History not available.</p>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h3 class="is-size-4">Data Visulization</h3>
              </div>
            </div>

            <div class="box" style="background-color: lightgray;">
              <div class="columns">
                <div class="column">
                  <h3 class="is-size-5">Trend Line</h3>
                  <p>Last 4 Weeks</p>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div> 
                    <trend
                      :data=averages
                      :gradient="['#145A32', '#2ECC71', '#D5F5E3']"
                      :padding="4"
                      :radius="8"
                      :stroke-width="5"
                      :min="0"
                      :max="5"
                      auto-draw>
                    </trend>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h3 class="is-size-5">Heat Map</h3>
              </div>
            </div>

            <div class="box" style="background-color: lightgray;">
              <div class="columns">
                <div class="column">
                  <div id="chart">
                    <apexchart type="heatmap" height="350" :options="chartOptions" :series="series"></apexchart>
                  </div>        
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h3 class="is-size-5">Scatter Graph</h3>
              </div>
            </div>

            <div class="box" style="background-color: lightgray;">
              <div class="columns">
                <div class="column">
                  <img class="axes2-target" :src="`${publicPath}img/Target.png`" >


                  <div id="scatterCchart">
                    <apexchart type="scatter" height="350" width="350" :options="scatterChartOptions" :series="scatterSeries"></apexchart>
                  </div>        
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <h3 class="is-size-4">Scorecard History</h3>
              </div>
            </div>

            <div class="columns" v-if="scorecardHistory.length == 0 && pleaseWait">
              <div class="column">
                <h3 class="blink is-size-5">Please wait, loading score history...</h3>
              </div>
            </div>

            <div class="columns" v-show="scorecardHistory.length == 0 && !pleaseWait">
              <div class="column">
                <p class="is-size-5 has-text-warning">No scorecards found.</p>
              </div>
            </div>

            <div class="box" style="background-color: lightgray; padding: 2px;">
              <div v-for="scorecard in scorecardHistory" :key="scorecard._id">
                <div class="columns is-mobile" style="max-width: 350px;">
                  <div class="column is-1">
                    <a title="View Scorecard" v-on:click="showScorecard(scorecard)"><i class="fas fa-bullseye"></i></a>
                  </div>
                  <div class="column is-1">
                    <a title="Share Scorecard" v-on:click="shareScorecard(scorecard)"><i class="fas fa-share"></i></a>
                  </div>
                  <div class="column is-1">
                    <a title="Email Scorecard" v-on:click="emailScorecard(scorecard)"><i class="fas fa-envelope"></i></a>
                  </div>
                  <div class="column is-1">
                    <a title="Show Summary" v-on:click="showSummaryModal(scorecard)"><i class="fa-solid fa-clipboard-list"></i></a>
                  </div>
                  <div class="column is-4">
                    <a v-on:click="showScorecard(scorecard)">{{ scorecard.dateTimeStamp | formatDate }}</a>
                  </div>
                  <div class="column is-4">
                    Avg {{ $parent.calculateAverageThrow(scorecard.players[0], scorecard).toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import CountryFlag from 'vue-country-flag';
import { GameType } from '@/enum/gameType.js';

export default {
  name: 'profile',
  components : {
    CountryFlag
  },
  computed: {
  },
  data () {
    return {
      GameType,
      debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
      publicPath: process.env.BASE_URL,
      gameType: '',
      profile: new Axes2Profile("0","","","","","","","","","","","","","", false),
      axe_list: [],
      country_list: [],
      scorecardHistory: [],
      averages: [],
      playerStatistics: {
        weeklyAverage : 0,
        monthlyAverage: 0 ,
        best6: 0,
        best36: 0,
        consecutive_bulls: 0
      },
      errorMessage: '',
      showError: false,
      isEditingProfile: false,
      pleaseWait: true,
      pleaseWaitStats: true,
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'heatmap',
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#015413"],
        title: {
          text: 'Throws (last 4 wks)'
        },
      },
      scatterSeries: [],
      scatterChartOptions: {
        chart: {
          width: 400,
          height: 400,
          type: 'scatter',
          zoom: {
            enabled: false,
            type: 'xy'
          },
        },
        title: {
          text: 'Hit locations (last 4 wks)'
        },
        xaxis: {
          display: false,
          tickAmount: 1,
          min: 0,
          max: 350,
          labels: {
            formatter: function (value) {
              return "";
            }
          }        
        },
        yaxis: {
          tickAmount: 1,
          min: 0,
          max: 350,
          labels: {
            formatter: function (value) {
              return "";
            }
          }        
        }
      }
    }
  },
  methods:{
    //duplicated
    showSummaryModal: function(scorecard) {
      //console.log("showScorecard");
      //console.log(scorecard);

      var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
      url += scorecard._id;

      var token = this.$parent.getApiToken();

      axios.get(url,{
          headers: {
              authorization: token
          }
      })
      .then((response) => {
        //console.log(response.data);
        this.$parent.showSummaryModal(response.data);
      }, (error) => {
        alert(error);
      });

    },
    showScorecard: function(scorecard) {
      this.$parent.showModal(scorecard);
    },
    shareScorecard: function(scorecard) {
      //alert(scorecard._id);
      window.open('/scorecard/' + scorecard._id);
    },
    emailScorecard: function(scorecard) {
      var email_string = "mailto:" + this.profile.email + "?subject=Scorecard&body=Your scorecard is here: https://axes2.ca/scorecard/" + scorecard._id + ".";
      window.open(email_string);
    },
    getDaysAgo: function(d,daysAgo) {
      var oldDate = new Date(d.getTime() - (daysAgo * 24 * 60 * 60 * 1000));
      return oldDate;
    },
    getStatistics: function (gameType) {
      var token = this.$parent.getApiToken();

      var url = (this.debugMode ? "http://localhost:8080/statistics" : "https://axes2api.azurewebsites.net/statistics")
          url += "/" + this.$auth.user.email + "/" + gameType;

      axios.get(url, {
          headers: {
            authorization: token
          }
        })
        .then((response) => {
          if (response.data.error != null) {
            this.pleaseWaitStats = false;
          } else {
            this.playerStatistics = response.data;
            this.pleaseWaitStats = false;
          }
        }, (error) => {
          this.pleaseWaitStats = false;
        });
    },
    calculateSeriesData: function(scorecards) {

      var today = new moment();
      var end = today.clone().weekday(6);
      var start = end.clone().subtract(28, "days");

      var weekList = [];

      var current = start.clone();
      //console.log(current.format());
      //console.log(end.format());
      while (current.isBefore(end)) {
        //console.log("added week: " + current.format())
        weekList.push(current.clone());
        current.add(7, 'days');
      }

      var weekScorecards = Array(weekList.length);
      for(var i = 0; i < weekScorecards.length; i ++) {
        weekScorecards[i] = [];
      }

      var currentScorecards = [];
      for(var i = 0; i < scorecards.length; i++) {
        if (moment(scorecards[i].dateTimeStamp) > start) {
          currentScorecards.push(scorecards[i]);
        }
      }

      for (var i = 0; i < currentScorecards.length; i++) {
        for (var x = 0; x < weekList.length; x ++) {
          //console.log(weekList[x].format());
          if (moment(currentScorecards[i].dateTimeStamp) > moment(weekList[x]) && 
            moment(currentScorecards[i].dateTimeStamp) < moment(weekList[x]).add(7,"days")) {
            weekScorecards[x].push(currentScorecards[i]);
            break;
          }
        }
      }

      //console.log(weekScorecards);
      //calculate # of 0,1,2,3,4,5 for each week (summed)
      var series = [];
      
      for (var i = 0; i < 6; i++) {
        //console.log("looking for throws of " + i);

        var totals = [];
        for (var x = 0; x < weekScorecards.length; x++) {
          //console.log("looking at week " + (x+1));

          var scorecardsForThisWeek = weekScorecards[x];

          var tot = 0;
          //get all throws of i in these scorecards
          for (var y = 0; y < scorecardsForThisWeek.length; y++) {
            //console.log("...inspecting socrecard");
            var scorecard = scorecardsForThisWeek[y]
            for(var z = 0; z < scorecard.rounds.length; z++) {
              var round = scorecard.rounds[z];
              for (var a = 0; a < round.matches.length; a++) {
                var match = round.matches[a];
                for (var b = 0; b < match.matchPlayers.length; b++) {
                  var matchPlayer = match.matchPlayers[b];
                  var matchPlayerId = matchPlayer.id;
                  for (var c = 0; c < matchPlayer.throws.length; c++) {
                    var pThrow = matchPlayer.throws[c];
                    //console.log(".....throw of " + pThrow.basicScore)
                    if (pThrow.basicScore == i) {
                      //console.log("GOT ONE!");
                      tot ++;
                    }
                  }
                }
              }
            }
          }

          totals.push(tot);
        }

        series.push({ "name" : i.toString(), data: totals });
      }
      //console.log("SERIES:");
      //console.log(series);

      this.series = series;
    },
    calculateScatterSeriesData: function(scorecards) {
      var today = new moment();
      var end = today.clone().weekday(6);
      var start = end.clone().subtract(28, "days");

      var day = 0;

      var weekList = [];

      var current = start.clone();
      //console.log(current.format());
      //console.log(end.format());
      while (current.isBefore(end)) {
        //console.log("added week: " + current.format())
        weekList.push(current.clone());
        current.add(7, 'days');
      }      

      var weekScorecards = Array(weekList.length);
      for(var i = 0; i < weekScorecards.length; i ++) {
        weekScorecards[i] = [];
      }

      var currentScorecards = [];
      for(var i = 0; i < scorecards.length; i++) {
        if (moment(scorecards[i].dateTimeStamp) > start) {
          currentScorecards.push(scorecards[i]);
        }
      }

      for (var i = 0; i < weekList.length; i++) {
        //console.log(weekList[i].format('LLLL'));
      }

      for (var i = 0; i < currentScorecards.length; i++) {
        for (var x = 0; x < weekList.length; x ++) {
          //console.log(weekList[x].format());
          if (moment(currentScorecards[i].dateTimeStamp) > moment(weekList[x]) && 
            moment(currentScorecards[i].dateTimeStamp) < moment(weekList[x]).add(7,"days")) {
            weekScorecards[x].push(currentScorecards[i]);
            break;
          }
        }
      }

      var series = [];

      for (var x = 0; x < weekScorecards.length; x++) {
        //console.log("looking at week " + (x+1));

        var scorecardsForThisWeek = weekScorecards[x];
        var positions = [];
        //get all throws of i in these scorecards
        for (var y = 0; y < scorecardsForThisWeek.length; y++) {
          //console.log("...inspecting socrecard");
          var scorecard = scorecardsForThisWeek[y]
          for(var z = 0; z < scorecard.rounds.length; z++) {
            var round = scorecard.rounds[z];
            for (var a = 0; a < round.matches.length; a++) {
              var match = round.matches[a];
              for (var b = 0; b < match.matchPlayers.length; b++) {
                var matchPlayer = match.matchPlayers[b];
                var matchPlayerId = matchPlayer.id;
                for (var c = 0; c < matchPlayer.throws.length; c++) {
                  var pThrow = matchPlayer.throws[c];
                  //console.log(".....position of " + pThrow.xPos + ", " + pThrow.yPos);
                  var arr = [];
                  arr.push(pThrow.xPos);
                  arr.push(pThrow.yPos);
                  positions.push(arr);
                }
              }
            }
          }
        }
        series.push({ "name" : (x+1).toString(), data: positions });
      }
      this.scatterSeries = series;
    },
    getScoreCards: function (gameType) {
      var token = this.$parent.getApiToken();


      var service_name = (gameType === "Round-Robin" ? "subscriberhistory" : "history");

      var url = (this.debugMode ? "http://localhost:8080" : "https://axes2api.azurewebsites.net")
          url += "/" + service_name + "/" + this.$auth.user.email + "/" + gameType;

      axios.get(url, {
          headers: {
            authorization: token
          }
        })
        .then((response) => {
          if (response.data.error != null) {
            this.errorMessage = response.data.error;
            this.showError = true;
            this.pleaseWait = false;
          } else {

            this.calculateSeriesData(response.data);
            this.calculateScatterSeriesData(response.data);

            var data = response.data.sort((function (a, b) { 
              return new Date(b.dateTimeStamp) - new Date(a.dateTimeStamp) 
            }));
            var start = moment().subtract(28, "days");

            for(var i = 0; i < data.length; i++) {
              if (moment(data[i].dateTimeStamp) >= start) {
                var avg = this.$parent.calculateAverageThrow(this.$auth.user, data[i]);
                data[i].average = avg;
                //var avg = 1;
                //console.log("adding ave to list");
                //console.log("avg ",avg);
                this.averages.push(avg);
              }
            }
            //this.averages.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));
            //console.log("this.averages:");
            //console.log(this.averages);
            this.scorecardHistory = data;
            this.pleaseWait = false;
          }
        }, (error) => {
          this.errorMessage = error;
          this.showError = true;
          this.pleaseWait = false;
        });
    },
    getAxeList() {
        //console.log("get axe list")
        var token = this.$parent.getApiToken();
        var url = (this.debugMode ? "http://localhost:8080/axe_list" : "https://axes2api.azurewebsites.net/axe_list")
        axios.get(url, {
            headers: {
                authorization: token
            }
        })
        .then((response) => {
            this.axe_list = response.data.axes;
        }, (error) => {
        //console.log(error);
        });
    },
    getProfile() {
        //console.log("get profile")
        var token = this.$parent.getApiToken();
        var url = (this.debugMode ? "http://localhost:8080/profile" : "https://axes2api.azurewebsites.net/profile")
        url += "/" + this.$auth.user.email;
        axios.get(url, {
            headers: {
                authorization: token
            }
        })
        .then((response) => {
            //console.log(response.data)

            var profile = new Axes2Profile(
              response.data._id , 
              (response.data.nickname != undefined ? response.data.nickname : ""), 
              (response.data.display_name != undefined ? response.data.display_name : ""), 
              (response.data.name != undefined ? response.data.name : ""), 
              (response.data.given_name != undefined ? response.data.given_name : ""), 
              (response.data.family_name != undefined ? response.data.family_name : ""), 
              (response.data.email != undefined ? response.data.email : ""), 
              (response.data.picture != undefined ? response.data.picture : ""), 
              (response.data.country != undefined ? response.data.country : ""), 
              (response.data.axe != undefined ? response.data.axe : ""), 
              (response.data.axe_other != undefined ? response.data.axe_other : ""), 
              (response.data.home_town != undefined ? response.data.home_town : ""), 
              (response.data.club != undefined ? response.data.club : ""),
              (response.data.bio != undefined ? response.data.bio : ""),
              (response.data.public_profile != undefined ? response.data.public_profile : false));

            this.profile = profile;
            
            if (response.data._id != undefined) this.profile.id = response.data._id;
        }, (error) => {
            //console.log(error);
        });
    },
    editProfile: function() {
      this.isEditingProfile = true;
    },
    cancelProfile: function() {
      this.isEditingProfile = false;
    },
    isValidData: function(profile) {
      var msg = "";
      if (profile.bio != null && profile.bio.length > 250) {
        msg += "Bio cannot be more than 250 characters (it is " + profile.bio.length  + ").\n";
      }
      return msg;
    },
    submitProfile: function() {
      //console.log(this.profile)
      var msg = this.isValidData(this.profile);
      if (msg != "") {
        alert(msg);
      } else {
        if (this.profile._id == "0") {
          //alert("...save profile...");
          //this.profile.nickname = this.$auth.user.nickname;
          //this.profile.name = this.$auth.user.name;
          //this.profile.given_name = this.$auth.user.given_name;
          //this.profile.family_name = this.$auth.user.family_name;
          //this.profile.email = this.$auth.user.email;
          //this.profile.picture = this.$auth.user.picture;
          //if (this.profile.axe != 'Other') this.profile.axe_other = "";
          this.saveProfile(this.profile);
          //alert("save")
        } else {
          //alert("update")
          //alert("...update profile...");
          this.updateProfile(this.profile);
        }
      }
    },
    saveProfile: function(profile) {
      var url = (this.debugMode ? "http://localhost:8080/profile" : "https://axes2api.azurewebsites.net/profile")
      var token = this.$parent.getApiToken();

      delete profile._id;
      delete profile.id;

      axios.post(url, 
        {
          profile: profile
        },
        {
          headers: {
              authorization: token
            }
        }
      )
      .then((response) => {
        //console.log(response);
        this.profile._id = response.data.insertedIds[0];
        this.isEditingProfile = false;
        //alert("Profile added.");      
      }, (error) => {
        alert("Error adding profile to Axes2.");
        //console.log(error);
      });
    },
    updateProfile: function(profile) {
      var url = (this.debugMode ? "http://localhost:8080/profile" : "https://axes2api.azurewebsites.net/profile")
      url += "/" + profile.email;
      var token = this.$parent.getApiToken();
      axios.patch(url, 
        {
          profile: profile
        },
        {
          headers: {
              authorization: token
            }
        }
      )
      .then((response) => {
        //console.log(response);
        this.isEditingProfile = false;
        //alert("Profile updated.");      
      }, (error) => {
        alert("Error updating profile in Axes2.");
        //console.log(error);
      });
    },
    getCountryList() {
        var token = this.$parent.getApiToken();
        var url = (this.debugMode ? "http://localhost:8080/country_list" : "https://axes2api.azurewebsites.net/country_list")
        axios.get(url, {
            headers: {
                authorization: token
            }
        })
        .then((response) => {
            this.country_list = response.data.countries.sort(this.sortArray);
        }, (error) => {
          console.log(error);
        });
    },
    sortArray(x, y){
      if (x.country_name < y.country_name) {return -1;}
      if (x.country_name > y.country_name) {return 1;}
      return 0;
    },    
    pickGameType: function(gameType) {
      this.gameType = gameType;
      this.getData();
    },
    getData: function() {
      this.pleaseWaitStats = true;
      this.playerStatistics.weeklyAverage = 0;
      this.playerStatistics.monthlyAverage = 0;
      this.playerStatistics.best6 = 0;
      this.playerStatistics.best36 = 0;
      this.playerStatistics.consecutive_bulls = 0;
      this.averages = [];
      this.scorecardHistory = [];

      this.pleaseWait = true;

      this.getAxeList();
      this.getCountryList();
      this.getProfile()
      this.getScoreCards(this.gameType);
      this.getStatistics(this.gameType);
    },
    isAdmin() {
          return this.$parent.isAdmin();
    }
  },
  mounted(){
    this.gameType = 'Solo';
    this.getData();
  }
}

function Axes2Profile(id, nickname, display_name, name, given_name, family_name, email, picture, country, axe, axe_other, home_town, club, bio, public_profile) {
	this._id = id;
  this.nickname = nickname;
  this.display_name = display_name;
  this.name = name;
  this.given_name = given_name;
  this.family_name = family_name;
  this.email = email;
  this.picture = picture;
  this.country = country;
  this.axe = axe;
  this.axe_other = axe_other;
  this.home_town = home_town;
  this.club = club;
  this.bio = bio;
  this.public_profile = public_profile;
}
</script>

<style lang="scss" scoped>
.axes2-target {
  width: 240px; 
  height: 240px; 
  opacity: 25%; 
  position: absolute; 
  margin-top: 70px; 
  margin-left: 60px;
}
#player-profile h1,h2,h3,h4,h5,h6 {
  color: black !important;
}
  @media screen and (min-width: 600px) {
    /*.statistics {
      width: 50%;
    }*/
  }
  .tabs {
    font-size: 1.25em;
  }
  .tab {
    margin-left: 10px; 
    margin-right: 10px;
    background-color: lightgray;
    border: solid black 2px;
    border-radius: 10px;
    font-weight: normal;
    padding: 8px;
    cursor: pointer;
  }
  .tab :hover {
    font-weight: bold;
  }
  .is-active {
    background-color: rgb(188, 253, 188);
    font-weight: bold;
    color: blue;
  }
  h3 {
    color: black;
  }
  li {
    margin-top: 10px;
  }
  a {
    color: darkblue;
    text-decoration: underline;
  }
  .box {
      background-color: #bebebe;
  }
  .hero {
    background-color: black;
  }
  .profile {
    background-color: lightgray;
    font-family: Verdana !important;
  }
  .profile-image {
    /*border-radius: 50%;*/
  }
  .is-clickable {
    cursor: pointer;
  }
  .blink {
    color: #e08e11;
    animation: blink-animation 1s steps(5, start) infinite;
    -webkit-animation: blink-animation 1s steps(5, start) infinite;
  }
  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
</style>